import React from "react";
import Langbox from "./langbox.jsx";
import Room from "./room.jsx";
import Discount from "./discount.jsx";
import Extra from "./extra.jsx";
import { SelectField, InputField } from "./fields.jsx";
import { AvailabilityPopup } from "./availability.jsx";
import htmlToDom from "html-react-parser";

class Unit extends React.Component {
  unit = this.props.unit;
  index = this.props.index;

  constructor(props) {
    super(props);
    let self = this;
    this.image = this.image.bind(this);
    this.addDynamicField = this.addDynamicField.bind(this);
    this.addPictures = this.addPictures.bind(this);
    this.addEquipments = this.addEquipments.bind(this);
    this.addLangbox = this.addLangbox.bind(this);
    this.removeDynamicField = this.removeDynamicField.bind(this);
    this.removeLangbox = this.removeLangbox.bind(this);
    this.prefix = this.props.dataset.prefix || "";
    this.fieldName = this.props.dataset.fieldName || "units";
    this.dynamicFields = {
      rooms: {
        type: [],
        single_beds: [],
        double_beds: [],
        day_beds: [],
        other_beds: [],
      },
      taglines: { langbox: [] },
      descriptions: { langbox: [] },
      extras: { type: [], price: [] },
      discounts: { type: [], value: [] },
    };
    this.widgets = {
      rooms: $(rentalUnitsPrototype)
        .find("#rental_units___name___rooms")
        .data("prototype"),
      discounts: $(rentalUnitsPrototype)
        .find("#rental_units___name___discounts")
        .data("prototype"),
      extras: $(rentalUnitsPrototype)
        .find("#rental_units___name___extras")
        .data("prototype"),
      taglines: $(rentalUnitsPrototype)
        .find("#rental_units___name___taglines")
        .data("prototype"),
      descriptions: $(rentalUnitsPrototype)
        .find("#rental_units___name___descriptions")
        .data("prototype"),
    };
    this.pictureList = JSON.parse(this.props.dataset.pictures) || [];
    this.equipments = JSON.parse(this.props.dataset.equipments) || [];
    this.rentalId = this.props.dataset.id || [];

    ["rooms", "taglines", "descriptions", "discounts", "extras"].forEach(
      (type) => {
        let fieldType = self.dynamicFields[type];
        Object.keys(fieldType).forEach((field) => {
          if (field == "langbox") {
            delete self.dynamicFields[type]["langbox"];
            const fieldId = `#${self.prefix}_${self.fieldName}___name___${type}___name__`;
            const labelFor = `${self.prefix}_${self.fieldName}___name___${type}___name__`;
            self.dynamicFields[type]["form"] = $(self.widgets[type]).find(
              fieldId
            );
            self.dynamicFields[type]["label"] = $(self.widgets[type]).find(
              `label[for="${labelFor}"]`
            );
          } else {
            const fieldId = `#${self.prefix}_${self.fieldName}___name___${type}___name___${field}`;
            const labelFor = `${self.prefix}_${self.fieldName}___name___${type}___name___${field}`;
            if ($(self.widgets[type]).find(fieldId).length) {
              self.dynamicFields[type][field]["form"] = $(
                self.widgets[type]
              ).find(fieldId);
              self.dynamicFields[type][field]["label"] = $(
                self.widgets[type]
              ).find(`label[for="${labelFor}"]`);
            }
          }
        });
      }
    );

    this.state = {
      type: "apartment",
      rooms: [],
      extras: [],
      discounts: [],
      taglines: null,
      picture_selection: [],
      equipments: [],
      descriptions: null,
      extrasKey: 0,
      discountsKey: 0,
      roomsKey: 0,
    };
  }

  image(pictureId, size, format) {
    return (
      image_base_url +
      this.rentalId +
      "/" +
      (size || "s") +
      "/" +
      pictureId +
      "." +
      (format || "jpg")
    );
  }

  addPictures(picture) {
    if (picture !== undefined) {
      let picture_selection = this.state.picture_selection;
      if (this.state.picture_selection.includes(picture)) {
        picture_selection = picture_selection.filter((el) => el !== picture);
      } else {
        Array.prototype.push.apply(picture_selection, [picture]);
      }
      this.setState({
        picture_selection: picture_selection,
      });
    }
  }
  addEquipments(equipment) {
    if (equipment !== undefined) {
      let equipments = this.state.equipments;
      if (this.state.equipments.includes(equipment)) {
        equipments = equipments.filter((el) => el !== equipment);
      } else {
        Array.prototype.push.apply(equipments, [equipment]);
      }
      this.setState({
        equipments: equipments,
      });
    }
  }

  addDynamicField(unit, type, values, norepeat) {
    let self = this;
    let newField = {};
    let add_field = true;
    let selected_options = [];

    let name_par_type = "\\[__name__\\]\\[" + type + "\\]";
    let name_par_type_regex = new RegExp(name_par_type, "g");
    let type_par_name = "\\[" + type + "\\]\\[__name__\\]";
    let type_par_name_regex = new RegExp(type_par_name, "g");
    let name_under_type = "__name___" + type;
    let name_under_type_regex = new RegExp(name_under_type, "g");
    let type_under_name = type + "___name__";
    let type_under_name_regex = new RegExp(type_under_name, "g");

    Object.keys(self.dynamicFields[type]).forEach((key, index) => {
      let formInput = self.dynamicFields[type][key]["form"]
        .clone()
        .addClass("mdc-text-field__input")
        .wrap("<helper>")
        .parent()
        .html()
        .replace(name_par_type_regex, "[" + unit.key + "][" + type + "]")
        .replace(name_under_type_regex, unit.key + "_" + type)
        .trim()
        .replace(
          type_par_name_regex,
          "[" + type + "][" + self.state[type + "Key"] + "]"
        )
        .replace(type_under_name_regex, type + "_" + self.state[type + "Key"]);
      let formLabel = self.dynamicFields[type][key]["label"]
        .clone()
        .addClass("mdc-floating-label mdc-floating-label--float-above")
        .wrap("<helper>")
        .parent()
        .html()
        .replace(name_under_type_regex, unit.key + "_" + type)
        .replace(type_under_name_regex, type + "_" + self.state[type + "Key"]);

      var template = document.createElement("template");
      template.innerHTML = formInput;
      newField[key] = {
        form: formInput.replace("value", "defaultValue"),
        class: template.content.firstChild.getAttribute("class"),
        value:
          values !== undefined && values !== null && values[key] != null
            ? values[key]
            : template.content.firstChild.getAttribute("value") || null,
        name: template.content.firstChild.getAttribute("name"),
        min: template.content.firstChild.getAttribute("min"),
        minlength: template.content.firstChild.getAttribute("minlength"),
        pattern: template.content.firstChild.getAttribute("pattern"),
        max: template.content.firstChild.getAttribute("max"),
        maxlength: template.content.firstChild.getAttribute("maxlength"),
        required: template.content.firstChild.getAttribute("required"),
        id: template.content.firstChild.getAttribute("id"),
        type:
          template.content.firstChild.getAttribute("type") ||
          template.content.firstChild.tagName.toLowerCase(),
        label: formLabel,
      };
      if (newField[key].type == "select") {
        if (norepeat == true) {
          $("select[id^='rental_units_" + unit.key + "_" + type + "']")
            .find("option:selected")
            .each(function () {
              const optionValue = $(this).val();
              if (!selected_options.includes(optionValue)) {
                selected_options.push(optionValue);
              }
            });
        }
        newField[key].options = [];
        self.dynamicFields[type][key]["form"]
          .find("option")
          .each((index, option) => {
            let newOption = {
              value: option.value,
              label: option.label,
              disabled:
                norepeat === true && selected_options.includes(option.value),
            };
            newField[key].options.push(newOption);
          });
        if (
          norepeat == true &&
          self.dynamicFields[type][key]["form"].find("option").length ==
            selected_options.length
        ) {
          add_field = false;
        }
      }
    });
    if (add_field == true) {
      newField["key"] = self.state[type + "Key"];
      let fields = this.state[type];
      Array.prototype.push.apply(fields, [newField]);
      self.setState({
        [type]: fields,
        [type + "Key"]: ++self.state[type + "Key"],
      });
      if (norepeat == true) {
        self.removeUnavailableSelectOptions();
      }
    }
  }

  addLangbox(unit, type, value) {
    let self = this;
    let newField = {};
    let field = self.dynamicFields[type];

    let name_par_type = "\\[__name__\\]\\[" + type + "\\]";
    let name_par_type_regex = new RegExp(name_par_type, "g");
    let type_par_name = "\\[" + type + "\\]\\[__name__\\]";
    let type_par_name_regex = new RegExp(type_par_name, "g");
    let name_under_type = "__name___" + type;
    let name_under_type_regex = new RegExp(name_under_type, "g");
    let type_under_name = type + "___name__";
    let type_under_name_regex = new RegExp(type_under_name, "g");

    let formInput = field["form"]
      .clone()
      .addClass(
        "mdc-text-field__input" +
          (type == "descriptions" ? " mdc-text-field__textarea minh-100" : "")
      )
      .wrap("<helper>")
      .parent()
      .html()
      .replace(name_par_type_regex, "[" + unit.key + "][" + type + "]")
      .replace(name_under_type_regex, unit.key + "_" + type)
      .trim()
      .replace(
        type_par_name_regex,
        "[" + type + "][" + self.state[type + "Key"] + "]"
      )
      .replace(type_under_name_regex, type + "_" + self.state[type + "Key"]);
    let formLabel = field["label"]
      .clone()
      .addClass("mdc-floating-label mdc-floating-label--float-above")
      .wrap("<helper>")
      .parent()
      .html()
      .replace(name_under_type_regex, unit.key + "_" + type)
      .replace(type_under_name_regex, type + "_0");

    newField["value"] = value;
    newField["prototype"] = {
      form: formInput,
      label: formLabel,
    };

    self.setState({
      [type]: newField,
    });
  }

  removeUnit(item) {
    this.props.removeUnit(item);
  }
  removeDynamicField(type, object) {
    this.setState({
      [type]: this.state[type].filter((el) => el.key !== object.key),
    });
    this.removeUnavailableSelectOptions();
  }
  removeLangbox(type) {
    this.setState({
      [type]: null,
    });
  }

  taglineTrigger(unitIndex, type, capacity, count, price) {
    let per = window.Translator.transChoice(
      "units.taglines.per",
      parseInt(count),
      {
        count: parseInt(count),
        type: type,
      },
      "js"
    );
    let state = {
      count: parseInt(count),
      type: type,
      capacity: parseInt(capacity),
      price: parseFloat(price),
      taglinePlaceholder:
        window.Translator.transChoice(
          "units.taglines.count",
          parseInt(count),
          {
            count: parseInt(count),
            type: type,
          },
          "js"
        ) +
        window.Translator.transChoice(
          "units.taglines.capacity",
          parseInt(capacity),
          {
            type: type,
            per: per.replace(/&nbsp;/g, " "),
            capacity: parseInt(capacity),
          },
          "js"
        ) +
        window.Translator.transChoice(
          "units.taglines.price",
          parseInt(capacity) > 1 && parseInt(price) > 4
            ? parseInt(capacity)
            : parseInt(price) > 4 && type != "SINGLE"
              ? parseInt(capacity)
              : 0,
          {
            price:
              "" +
              Math.round(
                (parseFloat(price) > 4 ? parseFloat(price) : 0) /
                  (parseInt(capacity) > 0 ? parseInt(capacity) : 1)
              ),
          },
          "js"
        ),
    };
    this.setState(state);
  }

  initializeUnitFields = () => {
    return new Promise((resolve, reject) => {
      let self = this;
      [
        "taglines",
        "descriptions",
        "extras",
        "discounts",
        "rooms",
        "picture_selection",
        "equipments",
      ].forEach((field) => {
        if (typeof self.props.unit[field] !== "undefined") {
          switch (field) {
            case "picture_selection":
              self.setState({ picture_selection: self.props.unit[field] });
              break;
            case "equipments":
              self.setState({ equipments: self.props.unit[field] });
              break;
            case "descriptions":
            case "taglines":
              self.addLangbox(self.unit, field, self.props.unit[field]);
              break;
            case "extras":
            case "discounts":
              self.props.unit[field].forEach((value) => {
                self.addDynamicField(self.unit, field, value, true);
              });
              break;
            case "rooms":
              self.props.unit[field].forEach((value) => {
                self.addDynamicField(self.unit, field, value);
              });
              break;
            default:
              break;
          }
        }
      });
      resolve();
    });
  };

  removeUnavailableSelectOptions() {
    setTimeout(() => {
      let dynamicFields = document.querySelectorAll(
        ".unit-dynamic-field.no-repeat"
      );
      dynamicFields.forEach(function (dynamicField) {
        let selectedOptions = [];
        let selects = dynamicField.querySelectorAll("select");
        let selectsLength = selects.length;
        let optionsLength = selects[0].querySelectorAll("option").length || 0;
        selects.forEach(function (select, idx) {
          select.querySelectorAll("option").forEach(function (option, idxopt) {
            option.disabled = false;
            if (selectedOptions.includes(option.value)) {
              option.disabled = true;
            } else {
              if (option.selected && !selectedOptions.includes(option.value)) {
                selectedOptions.push(option.value);
              }
            }
          });
          if (idx < selectsLength - 1) {
            select.addEventListener("mousedown", function (event) {
              event.preventDefault();
            });
          }
        });
        if (selectedOptions.length <= optionsLength - 1) {
          dynamicField
            .querySelector(".add-dynamic-field")
            .classList.remove("hidden");
        } else {
          dynamicField
            .querySelector(".add-dynamic-field")
            .classList.add("hidden");
        }
      });
    }, 100);
  }

  componentDidMount() {
    let self = this;

    self.initializeUnitFields().finally(() => {
      self.removeUnavailableSelectOptions();
    });

    document
      .querySelectorAll(
        "#unit" +
          self.props.index +
          " .tagline-changer input, #unit" +
          self.props.index +
          " .tagline-changer select"
      )
      .forEach((field) => {
        field.addEventListener("change", function (e) {
          let sel = document.querySelector(
            "#unit" + self.props.index + " .tagline-changer select"
          );
          let count =
            document.querySelector(
              "#unit" +
                self.props.index +
                " .tagline-changer[data-field=count] input"
            ).value || 1;
          let capacity =
            document.querySelector(
              "#unit" +
                self.props.index +
                " .tagline-changer[data-field=capacity] input"
            ).value || 1;
          let price =
            document.querySelector(
              "#unit" +
                self.props.index +
                " .tagline-changer[data-field=price] input"
            ).value || 0;
          let typeTranslated = window.Translator.trans(
            "units.type." +
              (count > 1 ? "plural." : "singular.") +
              sel.options[sel.selectedIndex].value,
            {},
            "js"
          );
          self.setState({ type: typeTranslated });
          self.taglineTrigger(
            self.props.index,
            typeTranslated,
            capacity,
            count,
            price
          );
        });
      });
    document
      .querySelector("#unit" + self.props.index + " .tagline-changer select")
      .dispatchEvent(new Event("change"));
  }

  createDefaultDynamicHint(type) {
    let self = this;
    return (
      <p className="add-hint">
        <button
          type="button"
          onClick={() => {
            this.addDynamicField(this.props.unit, type);
          }}
          className="add-dynamic-field small btn black p-0 mb-1"
          title={window.Translator.trans("units.buttons.add." + type, {}, "js")}
        >
          <svg className="icon new" width="16" height="16">
            <use href="#new"></use>
          </svg>
          <span>
            {window.Translator.trans("units." + type + ".empty", {}, "js")}{" "}
          </span>
        </button>
      </p>
    );
  }

  createDefaultLangboxHint(type) {
    let self = this;
    return (
      <p className="add-hint">
        <button
          type="button"
          onClick={() => {
            this.addLangbox(this.props.unit, type);
          }}
          className="add-description small btn inline-block small black p-0 mb-1"
          title={window.Translator.trans("units.buttons.add." + type, {}, "js")}
        >
          <svg className="icon new" width="16" height="16">
            <use href="#new"></use>
          </svg>
          <span>
            {window.Translator.trans(
              "units.buttons.add." + type,
              {
                type: "type",
              },
              "js"
            )}
          </span>
        </button>
      </p>
    );
  }
  createDefaultTaglineHint() {
    let self = this;
    return (
      <p className="add-hint ib">
        <button
          type="button"
          className="add-tagline small btn inline-block small black p-0 mb-2"
          title={window.Translator.trans("units.taglines.empty", {}, "js")}
        >
          <span className="subheadline d-inline p-0 mt-0">
            {self.state.taglinePlaceholder}
          </span>
          <span
            title={window.Translator.trans(
              "units.buttons.add.taglines",
              {
                type: "type",
              },
              "js"
            )}
            onClick={() => {
              this.addLangbox(this.props.unit, "taglines");
            }}
          >
            <svg
              className={
                self.state.capacity > 0 ? "icon edit ms-1 mt-1 me-1" : "hidden"
              }
              width="12"
              height="12"
            >
              <use href="#edit"></use>
            </svg>
            <span className={self.state.capacity > 0 ? "hidden" : ""}>
              <svg className="icon new ms-1 me-1" width="12" height="12">
                <use href="#new"></use>
              </svg>
              {window.Translator.trans(
                "units.buttons.add.taglines",
                {
                  type: "type",
                },
                "js"
              )}
            </span>
          </span>
        </button>
      </p>
    );
  }

  render() {
    let self = this;
    let defaultPictureHint = (
      <p className="add-hint">
        <button
          type="button"
          className="add-picture small btn black p-0 mb-1 toggler"
          data-target={".pictureSelection" + this.props.index}
          data-toggle-class="hidden"
          title={window.Translator.trans(
            "units.buttons.add.pictures",
            {},
            "js"
          )}
        >
          <svg className="icon new" width="16" height="16">
            <use href="#new"></use>
          </svg>
          <span>
            {window.Translator.trans("units.pictures.empty", {}, "js")}{" "}
          </span>
        </button>
      </p>
    );
    let defaultEquipmentHint = (
      <p className="add-hint">
        <button
          type="button"
          className="add-equipment small btn black p-0  mb-1 toggler"
          data-target={".equipmentSelection" + this.props.index}
          data-toggle-class="hidden"
          title={window.Translator.trans(
            "units.buttons.add.equipments",
            {},
            "js"
          )}
        >
          <svg className="icon new" width="16" height="16">
            <use href="#new"></use>
          </svg>
          <span>
            {window.Translator.trans("units.equipments.empty", {}, "js")}{" "}
          </span>
        </button>
      </p>
    );
    let extraFieldsButton = (
      <p className="add-hint mt-1 mb-1">
        <button
          type="button"
          className="add-extra small btn inline-block small black p-0 mb-1 underline toggler"
          data-target={".extra" + this.props.index}
          data-toggle-class="hidden"
          title={window.Translator.trans("units.more_fields.empty", {}, "js")}
        >
          <span>
            {window.Translator.trans(
              "units.buttons.add.more_fields",
              {
                type: "type",
              },
              "js"
            )}
          </span>
        </button>
      </p>
    );

    let defaultTaglineHint = this.createDefaultTaglineHint();
    let defaultDescriptionHint = this.createDefaultLangboxHint("descriptions");
    let defaultDiscountHint = this.createDefaultDynamicHint("discounts");
    let defaultExtraHint = this.createDefaultDynamicHint("extras");
    let defaultRoomHint = this.createDefaultDynamicHint("rooms");

    let unitTitle =
      (this.props.unit.id.value != null
        ? window.Translator.trans("units.id", {}, "js") +
          " " +
          this.props.unit.id.value +
          " / "
        : "(" + window.Translator.trans("units.draft", {}, "js") + ") ") +
      this.state.type;
    return (
      <>
        <div
          className="rental-unit-edit bordered-fields d-flex"
          title={unitTitle}
          id={"unit" + this.props.index}
        >
          <InputField field={this.props.unit.id} />
          <div className="container-fluid">
            <div className="row gx-3">
              <div className="col-10">
                {this.state.taglines != null ? (
                  <div className="rental-unit-langbox-list-edit">
                    <Langbox
                      unitIndex={self.props.index}
                      langbox={this.state.taglines}
                      index={0}
                      removeLangbox={this.removeLangbox}
                      type={"taglines"}
                      placeholder={self.state.taglinePlaceholder}
                    />
                  </div>
                ) : (
                  defaultTaglineHint
                )}
              </div>
              <div className="col-12"></div>

              <div className="col-6 col-sm-3 col-lg-3 col-xl-2">
                <div
                  className="mdc-text-field select-field tagline-changer"
                  data-field="type"
                >
                  {htmlToDom(this.props.unit.type.label)}
                  <SelectField field={this.props.unit.type} />
                </div>
              </div>

              <div className="col-6 col-sm-2 col-xl-1">
                <div
                  className="mdc-text-field text-field tagline-changer"
                  data-field="count"
                >
                  {htmlToDom(this.props.unit.count.label)}
                  <InputField field={this.props.unit.count} />
                </div>
              </div>
              <div className="col-6 col-sm-2 col-xl-1 price">
                <div
                  className="mdc-text-field text-field tagline-changer"
                  data-field="price"
                >
                  {htmlToDom(this.props.unit.price.label)}
                  <InputField field={this.props.unit.price} />
                </div>
              </div>
              <div className="col-6 col-sm-2 col-xl-1">
                <div
                  className="mdc-text-field text-field tagline-changer"
                  data-field="capacity"
                >
                  {htmlToDom(this.props.unit.capacity.label)}
                  <InputField field={this.props.unit.capacity} />
                </div>
              </div>
              <div
                className={
                  "col-6 col-sm-3 col-lg-2 " +
                  (this.props.unit.capacity_extra.value > 0
                    ? ""
                    : "hidden extra" + this.props.index)
                }
              >
                <div className="mdc-text-field text-field">
                  {htmlToDom(this.props.unit.capacity_extra.label)}
                  <InputField field={this.props.unit.capacity_extra} />
                </div>
              </div>
              <div
                className={
                  "col-6 col-sm-3 col-lg-2 col-xl-1 hidden extra" +
                  this.props.index
                }
              >
                <div className="mdc-text-field text-field">
                  {htmlToDom(this.props.unit.size.label)}
                  <InputField field={this.props.unit.size} />
                </div>
              </div>
              <div
                className={
                  "col-6 col-sm-3 col-lg-2 " +
                  (this.props.unit.period_min.value > 1
                    ? ""
                    : "hidden extra" + this.props.index)
                }
              >
                <div className="mdc-text-field text-field">
                  {htmlToDom(this.props.unit.period_min.label)}
                  <InputField field={this.props.unit.period_min} />
                </div>
              </div>
              <div
                className={
                  "col-6 col-sm-3 col-lg-2 col-xl-1 price " +
                  (this.props.unit.deposit.value > 0
                    ? ""
                    : "hidden extra" + this.props.index)
                }
              >
                <div className="mdc-text-field text-field">
                  {htmlToDom(this.props.unit.deposit.label)}
                  <InputField field={this.props.unit.deposit} />
                </div>
              </div>
              <div
                className={
                  "col-6 col-sm-3 col-lg-2 price " +
                  (this.props.unit.cleaning.value > 0
                    ? ""
                    : "hidden extra" + this.props.index)
                }
              >
                <div className="mdc-text-field text-field">
                  {htmlToDom(this.props.unit.cleaning.label)}
                  <InputField field={this.props.unit.cleaning} />
                </div>
              </div>
              <div className={"col-12 col-sm-auto tc extra" + this.props.index}>
                {extraFieldsButton}
              </div>
              <div className="col-12"></div>
              <div className="col-12 col-md-8 col-lg-7">
                {this.state.descriptions != null ? (
                  <div className="rental-unit-langbox-list-edit">
                    <Langbox
                      unitIndex={self.props.index}
                      langbox={this.state.descriptions}
                      index={0}
                      removeLangbox={this.removeLangbox}
                      type={"descriptions"}
                      placeholder={window.Translator.trans(
                        "units.descriptions.empty",
                        {},
                        "js"
                      )}
                    />
                  </div>
                ) : (
                  defaultDescriptionHint
                )}
              </div>

              <div className="col-12 col-lg-9">
                {this.state.discounts.length > 0 ? (
                  <h3 className="subheadline pt-1 pb-2">
                    {window.Translator.trans(
                      "units.discounts.headline",
                      {
                        count: this.state.discounts.length,
                      },
                      "js"
                    )}{" "}
                    ({this.state.discounts.length})
                  </h3>
                ) : (
                  ""
                )}
                <div
                  className={
                    this.state.discounts.length > 0
                      ? "unit-dynamic-field no-repeat"
                      : ""
                  }
                >
                  {this.state.discounts.length > 0 &&
                    this.state.discounts.map((discount, index) => (
                      <Discount
                        key={discount.key}
                        unitIndex={this.unit.index}
                        discount={discount}
                        index={discount.key}
                        onChangeDynamicField={this.onChangeDynamicField}
                        removeDynamicField={this.removeDynamicField}
                      />
                    ))}
                  {this.state.discounts.length <= 0 ? (
                    defaultDiscountHint
                  ) : (
                    <button
                      type="button"
                      onClick={() => {
                        this.addDynamicField(
                          this.props.unit,
                          "discounts",
                          null,
                          true
                        );
                      }}
                      className="add-dynamic-field small btn black p-0 mt-1 ms-2 mb-1"
                      title={window.Translator.trans(
                        "units.buttons.add.discounts",
                        {},
                        "js"
                      )}
                    >
                      <svg className="icon new" width="16" height="16">
                        <use href="#new"></use>
                      </svg>
                      <span>
                        {window.Translator.trans(
                          "units.buttons.add.discounts",
                          {},
                          "js"
                        )}{" "}
                      </span>
                    </button>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-9">
                {this.state.extras.length > 0 ? (
                  <h3 className="subheadline pt-1 pb-2">
                    {window.Translator.trans(
                      "units.extras.headline",
                      {
                        count: this.state.extras.length,
                      },
                      "js"
                    )}{" "}
                    ({this.state.extras.length})
                  </h3>
                ) : (
                  ""
                )}
                <div
                  className={
                    this.state.extras.length > 0
                      ? "unit-dynamic-field no-repeat"
                      : ""
                  }
                >
                  {this.state.extras.length > 0 &&
                    this.state.extras.map((extra, index) => (
                      <Extra
                        key={extra.key}
                        unitIndex={this.unit.index}
                        extra={extra}
                        index={extra.key}
                        onChangeDynamicField={this.onChangeDynamicField}
                        removeDynamicField={this.removeDynamicField}
                      />
                    ))}
                  {this.state.extras.length <= 0 ? (
                    defaultExtraHint
                  ) : (
                    <button
                      type="button"
                      onClick={() => {
                        this.addDynamicField(
                          this.props.unit,
                          "extras",
                          null,
                          true
                        );
                      }}
                      className="add-dynamic-field small btn black p-0 mt-1 ms-2 mb-1"
                      title={window.Translator.trans(
                        "units.buttons.add.extras",
                        {},
                        "js"
                      )}
                    >
                      <svg className="icon new" width="16" height="16">
                        <use href="#new"></use>
                      </svg>
                      <span>
                        {window.Translator.trans(
                          "units.buttons.add.extras",
                          {},
                          "js"
                        )}{" "}
                      </span>
                    </button>
                  )}
                </div>
              </div>

              <div className="col-12">
                {this.state.rooms.length > 0 ? (
                  <h3 className="subheadline pt-1 pb-2">
                    {window.Translator.trans(
                      "units.rooms.headline",
                      {
                        count: this.state.rooms.length,
                      },
                      "js"
                    )}{" "}
                    ({this.state.rooms.length})
                  </h3>
                ) : (
                  ""
                )}

                <div
                  className={
                    this.state.rooms.length > 0 ? "unit-dynamic-field" : ""
                  }
                >
                  {this.state.rooms.length > 0 &&
                    this.state.rooms.map((room, index) => (
                      <Room
                        key={room.key}
                        unitIndex={this.unit.index}
                        room={room}
                        index={room.key}
                        removeDynamicField={this.removeDynamicField}
                      />
                    ))}
                  {this.state.rooms.length <= 0 ? (
                    defaultRoomHint
                  ) : (
                    <button
                      type="button"
                      onClick={() => {
                        this.addDynamicField(this.props.unit, "rooms");
                      }}
                      className="add-dynamic-field small btn black p-0 mt-1 ms-2 mb-1"
                      title={window.Translator.trans(
                        "units.buttons.add.rooms",
                        {},
                        "js"
                      )}
                    >
                      <svg className="icon new" width="16" height="16">
                        <use href="#new"></use>
                      </svg>
                      <span>
                        {window.Translator.trans(
                          "units.buttons.add.rooms",
                          {},
                          "js"
                        )}{" "}
                      </span>
                    </button>
                  )}
                </div>
              </div>

              <div className="col-12">
                {this.pictureList.length > 0 &&
                this.state.picture_selection.length > 0 ? (
                  <h3 className="subheadline p-0">
                    {window.Translator.trans(
                      "units.pictures.headline",
                      {
                        count: this.state.picture_selection.length,
                      },
                      "js"
                    ) +
                      " (" +
                      this.state.picture_selection.length +
                      ")"}
                  </h3>
                ) : this.pictureList.length > 0 ? (
                  defaultPictureHint
                ) : (
                  ""
                )}

                {this.pictureList.length > 0 ? (
                  <div
                    className={
                      "selection pictureSelection" +
                      this.props.index +
                      " fancy-input mb-1 " +
                      (this.state.picture_selection == 0 ? "hidden" : "")
                    }
                  >
                    {this.pictureList.map((picture, index) => (
                      <div key={index} className="ib m-0 me-1 ms-1">
                        <input
                          type="checkbox"
                          id={
                            "rental_units_" +
                            this.props.unit.key +
                            "_picture_" +
                            index
                          }
                          group={"rental[units][" + this.props.unit.key + "]"}
                          name={
                            "rental[units][" +
                            this.props.unit.key +
                            "][picture_selection][]"
                          }
                          value={picture.id}
                          onChange={() => {
                            this.addPictures(picture.id);
                          }}
                          checked={this.state.picture_selection.includes(
                            picture.id
                          )}
                        />
                        <label
                          htmlFor={
                            "rental_units_" +
                            this.props.unit.key +
                            "_picture_" +
                            index
                          }
                          title={picture.name}
                        >
                          <img
                            loading="lazy"
                            src={self.image(picture.id, "s", "jpg")}
                            title={picture.name}
                          />
                        </label>
                      </div>
                    ))}
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div className="col-12">
                {this.equipments.length > 0 &&
                this.state.equipments.length > 0 ? (
                  <h3 className="subheadline p-0">
                    {window.Translator.trans(
                      "units.equipments.headline",
                      {
                        count: this.state.equipments.length,
                      },
                      "js"
                    ) +
                      " (" +
                      this.state.equipments.length +
                      ")"}
                  </h3>
                ) : this.equipments.length > 0 ? (
                  defaultEquipmentHint
                ) : (
                  ""
                )}

                {this.equipments.length > 0 ? (
                  <div
                    className={
                      "selection equipment equipmentSelection" +
                      this.props.index +
                      " row fancy-input " +
                      (this.state.equipments == 0 ? "hidden" : "")
                    }
                  >
                    {this.equipments.map((equipment, index) => (
                      <div key={index} className="col-6 col-sm-4 col-lg-3">
                        <input
                          type="checkbox"
                          id={
                            "rental_units_" +
                            this.props.unit.key +
                            "_equipment_" +
                            index
                          }
                          group={"rental[units][" + this.props.unit.key + "]"}
                          name={
                            "rental[units][" +
                            this.props.unit.key +
                            "][equipments][]"
                          }
                          value={equipment.id}
                          onChange={() => {
                            this.addEquipments(equipment.id.toString());
                          }}
                          checked={this.state.equipments.includes(
                            equipment.id.toString()
                          )}
                        />
                        <label
                          htmlFor={
                            "rental_units_" +
                            this.props.unit.key +
                            "_equipment_" +
                            index
                          }
                        >
                          <svg
                            className={equipment.icon + " icon me-2"}
                            width="18"
                            height="18"
                          >
                            <use href={"#" + equipment.icon}></use>
                          </svg>
                          <em className="small">{equipment.name}</em>
                        </label>
                      </div>
                    ))}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <span
            className="pe-1 pointer action-remove flex-shrink-0"
            onClick={() => {
              if (
                confirm(
                  window.Translator.trans("confirm.delete.unit", {}, "js")
                )
              ) {
                this.removeUnit(this.props.unit);
              }
            }}
            title={window.Translator.trans("units.buttons.remove", {}, "js")}
          >
            <svg className="icon remove" width="12" height="12">
              <use href="#remove"></use>
            </svg>
          </span>
        </div>
      </>
    );
  }
}
export default Unit;
